import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { IncomingInvoiceReminderListItem } from "@msuite/utils/types";

/** Props Interface */
interface ReminderInvoiceCellProps {
	invoice: IncomingInvoiceReminderListItem["invoice"];
}

/** The invoice a reminder is about, or a tag saying no invoice matched it. */
export function ReminderInvoiceCell({ invoice }: ReminderInvoiceCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (invoice) return <span>{invoice.number ?? "–"}</span>;
	return (
		<Tag
			size="xs"
			color="amber"
			variant="plain"
		>
			{t("incoming_invoices.reminders.unmatched")}
		</Tag>
	);
}
